import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section id="faq" className="border-y border-background-200 bg-background-100/50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容范围、核实标准和投稿方式，这里是最常被问到的几个问题。
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-3-line"></i>
              还有别的疑问
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700">
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                      </span>
                    </button>
                    {isOpen ? (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6">
                        {item.a}
                      </p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}